import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import StatStrip from "@/components/sections/StatStrip";
import ContractCard from "@/components/sections/ContractCard";
import TaglineRotator from "@/components/sections/TaglineRotator";
import Manifesto from "@/components/sections/Manifesto";
import RvaClip from "@/components/sections/RvaClip";
import IQGame from "@/components/sections/IQGame";
import KingOfRetards from "@/components/sections/KingOfRetards";
import PfpMaker from "@/components/sections/PfpMaker";
import MemeGallery from "@/components/sections/MemeGallery";
import HowToBuy from "@/components/sections/HowToBuy";
import Tokenomics from "@/components/sections/Tokenomics";
import Roadmap from "@/components/sections/Roadmap";
import Socials from "@/components/sections/Socials";
import Footer from "@/components/sections/Footer";

const Home = () => {
  return (
    <main data-testid="home-page" className="min-h-screen">
      <Header />
      <Hero />
      <StatStrip />
      <ContractCard />
      <TaglineRotator />
      <Manifesto />
      <RvaClip />
      <KingOfRetards />
      <IQGame />
      <PfpMaker />
      <MemeGallery />
      <HowToBuy />
      <Tokenomics />
      <Roadmap />
      <Socials />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontFamily: "Caveat Brush, cursive",
              fontSize: "1.4rem",
              background: "#FFFDF6",
              color: "#1A1A1A",
              border: "4px solid #1A1A1A",
              boxShadow: "6px 6px 0 #1A1A1A",
              borderRadius: "14px",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
